import {
    getData,
} from './Services'

export const getMarcas = async () => {
    const res = await getData('/marcas/marcas_select');
    return res
}
